<script setup lang="ts">
import {
  PhxPicture as PhxsgCorePicture,
  type PhxPictureProps as PhxsgCorePictureProps,
} from '@sg-core/src/View/Components/Atoms/Picture';

withDefaults(defineProps<PhxsgCorePictureProps>(), {
  fade: undefined,
});
</script>

<template>
  <PhxsgCorePicture v-bind="$props" />
</template>
